import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  TextField,
  Alert,
  Snackbar,
} from '@mui/material';
import { getSettings, updateSettings } from '../../../app/api';
import { useTranslation } from '../../../app/LanguageContext';
import { SavingOverlay } from '../../core/public/SavingOverlay';

const SettingsPage = () => {
  const { translate } = useTranslation();
  const [formData, setFormData] = useState({
    order_default_validity_days: 7,
  });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const res = await getSettings();
      if (res.data) {
        setFormData({
          order_default_validity_days: res.data.order_default_validity_days ?? 7,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateSettings({
        order_default_validity_days: (() => {
          const v = parseInt(formData.order_default_validity_days, 10);
          return Number.isNaN(v) ? 7 : v;
        })(),
      });
      setSnackbar({ open: true, message: translate('settings.saved'), severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, maxWidth: 600, width: '100%', boxSizing: 'border-box' }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            type="number"
            label={translate('settings.order_default_validity_days')}
            helperText={translate('settings.order_default_validity_days_help')}
            value={formData.order_default_validity_days}
            onChange={(e) => setFormData((f) => ({ ...f, order_default_validity_days: e.target.value }))}
            inputProps={{ min: 0 }}
          />
          <Box sx={{ mt: 3 }}>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? translate('common.saving') : translate('common.save')}
            </Button>
          </Box>
        </Box>
      </Paper>

      <SavingOverlay open={loading} />

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert onClose={() => setSnackbar((s) => ({ ...s, open: false }))} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SettingsPage;

